// fix this;
/* eslint-disable no-empty */
const SessionStorageKey = {
  FILTER: 'filter',
};

export default class SessionStorage {
  static get storage() {
    if (typeof window !== 'undefined' && 'sessionStorage' in window) {
      return window.sessionStorage;
    }

    return {
      getItem() {},
      setItem() {},
      removeItem() {},
    };
  }

  static get(key) {
    try {
      return this.storage.getItem(key);
    } catch (e) {
      console.error(e);
    }
    return null;
  }

  static set(key, value) {
    try {
      this.storage.setItem(key, value);
    } catch (e) {
      console.error(e);
    }
  }

  static remove(key) {
    try {
      this.storage.removeItem(key);
    } catch (e) {
      console.error(e);
    }
  }

  static setFilterState(state) {
    try {
      SessionStorage.set(SessionStorageKey.FILTER, JSON.stringify(state));
    } catch (e) {}
  }

  static getFilterState() {
    try {
      return JSON.parse(SessionStorage.get(SessionStorageKey.FILTER));
    } catch (e) {
      return null;
    }
  }

  static removeFilterState() {
    try {
      SessionStorage.remove(SessionStorageKey.FILTER);
    } catch (e) {}
  }
}
